import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {LoginForm, LoginForm2FA, RenderOrEmpty} from '../../components';

import {
  finishSuccessLogin,
  login,
  login2FA,
  loginWithSSO,
  resendCode,
} from '../../actions/auth/login';
import LoginFormTOTPSetup from '../../components/LoginFormTOTPSetup/LoginFormTOTPSetup';
import {SOURCE_2FA_TYPES} from '../../actions/auth/constants';

function Login(props) {
  const {
    auth,
    auth2FA,
    finishSuccessLogin,
    authWithSSO,
    // eslint-disable-next-line no-shadow
    resendCode,
    isLoggedInFailed,
    loginType,
    isSecondFactorFailed,
    show2FAForm,
    source2FA,
  } = props;
  const checkAuthCode = (data, historyParam) => auth2FA(data, historyParam, true);
  const onSuccessfulLogin = (data, historyParam) => finishSuccessLogin(data, historyParam, true);

  /**
   * Render 2FA form depending on source2FA
   */
  const render2FAForm = () => {
    if (source2FA === SOURCE_2FA_TYPES.TOTP_LINK_DEVICE) {
      return (
        <LoginFormTOTPSetup
          finishSuccessLogin={onSuccessfulLogin}
        />
      );
    }

    return (
      <LoginForm2FA
        login2FA={checkAuthCode}
        source2FA={source2FA}
        resendCode={resendCode}
        isSecondFactorFailed={isSecondFactorFailed}
        canRecoverTOTP={true}
      />
    );
  };

  return (
    <>
      <RenderOrEmpty isShow={!show2FAForm}>
        <LoginForm
          login={auth}
          loginWithSSO={authWithSSO}
          isLoggedInFailed={isLoggedInFailed}
          loginType={loginType}
        />
      </RenderOrEmpty>
      <RenderOrEmpty isShow={show2FAForm}>
        {render2FAForm()}
      </RenderOrEmpty>
    </>
  );
}

Login.propTypes = {
  auth: PropTypes.func.isRequired,
  authWithSSO: PropTypes.func.isRequired,
  auth2FA: PropTypes.func.isRequired,
  finishSuccessLogin: PropTypes.func.isRequired,
  resendCode: PropTypes.func.isRequired,
  isLoggedInFailed: PropTypes.bool.isRequired,
  loginType: PropTypes.string.isRequired,
  isSecondFactorFailed: PropTypes.bool.isRequired,
  show2FAForm: PropTypes.bool,
  source2FA: PropTypes.string,
};

Login.defaultProps = {
  show2FAForm: false,
  source2FA: '',
};

const mapStateToProps = (state) => ({
  isLoggedInFailed: state.authReducer.isLoggedInFailed,
  loginType: state.authReducer.loginType,
  isSecondFactorFailed: state.authReducer.isSecondFactorFailed,
  show2FAForm: state.authReducer.show2FAForm,
  source2FA: state.authReducer.source2FA,
});

const mapDispatchToProps = (dispatch) => ({
  auth: bindActionCreators(login, dispatch),
  auth2FA: bindActionCreators(login2FA, dispatch),
  finishSuccessLogin: bindActionCreators(finishSuccessLogin, dispatch),
  authWithSSO: bindActionCreators(loginWithSSO, dispatch),
  resendCode: bindActionCreators(resendCode, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
